export default __webpack_public_path__ + "images/A8.205ff76.png";